'use es6';

import { Record } from 'immutable';
export default Record({
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  teamId: null,
  expiresAt: null,
  recentActivityAt: null,
  permissionSetId: null,
  scim: null,
  pending: null,
  partner: null,
  jita: null,
  hasTwoFactorConfigured: null,
  hasTwoFactorBackupCodes: null,
  emailSent: null,
  ownedAssetCount: null
});